import { password, compare } from '@rxweb/reactive-form-validators';

export class ResetPassword {
  @password({
    validation: {
      maxLength: 10,
      minLength: 5,
      digit: true,
      specialCharacter: true,
    },
  })
  password: string;
  @compare({ fieldName: 'password' })
  confirmPassword: string;
}
